import { useEffect, useState } from 'react';
import { useNetwork } from '../../context/Dashboard/contextNetwork.js';
import { useThemeMode } from '../../context/contextTheme.js';
import { downloadAgent } from '../../api/get/get-download.js';
import osOptions from '../../config/osOptions.js';

const ScanOS = () => {
  const { 
    selectedOS, setSelectedOS, 
    agentLoading, setAgentLoading 
  } = useNetwork();
  const { theme } = useThemeMode();
  const [downloaded, setDownloaded] = useState(false);
  const [downloadError, setDownloadError] = useState('');

  useEffect(() => {
    if (selectedOS) return;

    const platform = `${navigator.userAgentData?.platform || navigator.platform || ''} ${navigator.userAgent || ''}`
      .toLowerCase();
    const detectedOS = platform.includes('mac') || platform.includes('darwin')
      ? 'darwin'
      : platform.includes('win')
        ? 'windows'
        : platform.includes('linux')
          ? 'linux'
          : '';

    if (detectedOS) setSelectedOS(detectedOS);
  }, [selectedOS, setSelectedOS]);

  const handleDownload = async () => {
    const selected = osOptions.find(opt => opt.id === selectedOS);
    if (!selected) {
      setDownloadError('Select an operating system before downloading.');
      return;
    }

    try {
      setDownloadError('');
      setAgentLoading(true);
      await downloadAgent(selected.id);
      setDownloaded(true);
    } catch (error) {
      console.error('Download failed:', error.message);
      setDownloadError(error.message || 'The agent could not be downloaded.');
    } finally {
      setAgentLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center scan-card" style={{width: 302 }}>
      {/* Subtitle */}
      <div className="fs-3 fw-semibold mb-3 text-center heading">Download Agent</div>          

      {/* OS Options */}
      <div className="d-flex gap-3 mb-4">
        {osOptions.map((os) => (
          <div
            key={os.id}
            className={`
              os-card py-3 px-3 rounded-4
              d-flex flex-column align-items-center justify-content-center
              ${selectedOS === os.id ? 'border-primary bg-light' : 'border-secondary'}
            `}
            style={{
              width: 90,
              cursor: downloaded ? 'not-allowed' : 'pointer',
              borderColor: selectedOS === os.id ? theme.primary : theme.secondary,
              backgroundColor: selectedOS === os.id ? theme.textColor : theme.textColorInv,
              color: selectedOS === os.id ? theme.primary : theme.textMuted,
              boxShadow: selectedOS === os.id 
                ? `inset 0 0 0 2.6px ${theme.primary}`
                : `inset 0 0 0 1px ${theme.secondary}`,
              transition: 'all 0.2s ease',
            }}
            onClick={() => {
              if (!downloaded) {
                setSelectedOS(os.id);
                setDownloadError('');
              }
            }}
            disabled={downloaded} // Disable OS options once download is completed
          >
            <div className="text-center fw-semibold">
              <os.icon size={30} style={{ marginBottom: '8px' }} />
              <div>{os.label}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="fs-6 text-center fw-semibold mb-3 subheading" style={{ width: 280 }}>
        Select the OS below to download the agent.
      </div>

      {downloadError && (
        <div className="alert alert-danger py-2 w-100" role="alert">
          {downloadError}
        </div>
      )}

      {/* Download or Go to Scan Button */}
      <button
        className="btn btn-secondary rounded-4
        shadow-sm py-3 mt-3 w-100 fw-semibold fs-5"
        disabled={!selectedOS || agentLoading}
        onClick={handleDownload}
      >
        {downloaded ? 'Go to Scan' : agentLoading ? (
          <div className="d-flex justify-content-center align-items-center">
            <div className="spinner-border" role="status"></div>
            <span className="px-1"></span>
            <span>Downloading...</span>
          </div>
        ) : 'Download Agent'}
      </button>
    </div>
  );
};

export default ScanOS;
